/**
 * Добавить сообщения из модуля
 * @param i18n
 * @param module
 */
export function addMessegesFromModule(i18n: any, module: any): void {
  i18n.global.messages.en = {
    ...i18n.global.messages.en,
    ...module?.locales?.en || {}
  }

  i18n.global.messages.ru = {
    ...i18n.global.messages.ru,
    ...getRuMessages(module?.locales?.ru || {})
  }
}

/**
 * Получить русские сообщения
 */
export function getRuMessages(originalRu: Object): object {
  const ru = originalRu;
  const newRu = {};
  // Из ключей делаем значения
  for (const key in ru) {
    newRu[key] = key
  }

  return newRu
}